var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import Markdown from '../../../../markdown/markdown';
export var InfoStripContainer = styled(Markdown)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-color: ", ";\n    color: ", ";\n    font-family: ", ";\n    font-size: 0.8125rem;\n    padding: ", ";\n    border-radius: 0 0 ", "\n        ", ";\n\n    p {\n        margin: 0;\n    }\n\n    a,\n    a:hover,\n    a:visited,\n    a:focus,\n    a:active {\n        color: ", ";\n    }\n    a:hover {\n        text-decoration: unset;\n    }\n"], ["\n    background-color: ", ";\n    color: ", ";\n    font-family: ", ";\n    font-size: 0.8125rem;\n    padding: ", ";\n    border-radius: 0 0 ", "\n        ", ";\n\n    p {\n        margin: 0;\n    }\n\n    a,\n    a:hover,\n    a:visited,\n    a:focus,\n    a:active {\n        color: ", ";\n    }\n    a:hover {\n        text-decoration: unset;\n    }\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
}, function (_a) {
    var color = _a.color;
    return color;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.font.family.lato;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.small + " " + theme.spacing.xSmall + " " + theme.spacing.xSmall;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.border.radius.small;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.border.radius.small;
}, function (_a) {
    var color = _a.color;
    return color;
});
var templateObject_1;
